// context/DialogContext.tsx
import React, { createContext, useContext, useState } from 'react';

const DialogContext = createContext(null);

export function DialogProvider({ children }) {
  const [dialogState, setDialogState] = useState({
    open: false,
    content: null,
    maxWidth: 900,
  });

  const openDialog = (content, options = {}) => {
    setDialogState({ open: true, content, maxWidth: options.maxWidth || 900 });
  };

  const closeDialog = () => {
    setDialogState({ open: false, content: null, maxWidth: null });
  };

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog }}>
      {children}
      {dialogState.open && (
        <Dialog onClose={closeDialog} maxWidth={dialogState.maxWidth}>
          {dialogState.content}
        </Dialog>
      )}
    </DialogContext.Provider>
  );
}

export function useDialog() {
  return useContext(DialogContext);
}

// Dialog renders its children as passed content
function Dialog({ children, onClose, maxWidth }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(35,41,53,0.9)',
        zIndex: 999999999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '8px',
          maxHeight: '90vh',
          overflow: 'auto',
          maxWidth,
          width: '90%',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
